<label class="datetime-custom-filter__label">{{ label() }}</label>
<div class="datetime-custom-filter__dates">
    <div class="datetime-custom-filter__dates__start">
        <label for="startDate">Start Date</label>
        <p-datepicker
            class="datetime-custom-filter__dates__start"
            inputId="startDate"
            placeholder="Start date"
            iconDisplay="input"
            hourFormat="12"
            [ngModel]="date().startDate"
            (ngModelChange)="updateStartDate($event)"
            [showTime]="true"
            [showIcon]="true"
            [maxDate]="maxDate()" />
    </div>
    <!--  TODO: fix icons alignment and color-->
    <div class="datetime-custom-filter__dates__end">
        <label for="endDate">End Date</label>
        <p-datepicker inputId="endDate" placeholder="End date" iconDisplay="input" hourFormat="12" [ngModel]="date().endDate" (ngModelChange)="updateEndDate($event)" [showTime]="true" [showIcon]="true" [minDate]="minDate()" />
    </div>
</div>
